import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { interceptorProviders } from './interceptors/interceptors';
import { MaterialModule } from './modules/material.module';
import { TasksModule } from './modules/tasks/tasks.module';
import { AuthService } from './services/auth.service';
import { CustomersState } from './states/customers-state/customers.state';
import { CustomerUsersState } from './states/customerUsers-state/customerUsers.state';
import { PluginsState } from './states/plugins-state/plugins.state';
import { TasksState } from './states/tasks-state/tasks.state';
import { UserState } from './states/user-state/user.state';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { registerLocaleData } from '@angular/common';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';
import { ToastrModule } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AuthGuard } from './services/guards/auth-guard.service';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HeaderComponent } from './shared/components/header/header.component';

import localeNl from '@angular/common/locales/nl';
import { UnsavedChangesService } from './services/unsavedChanges.service';
import { LoadingIndicatorComponent } from './shared/components/loading-indicator/loading-indicator.component';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { ActionsState } from './states/actions-state/actions.state';
import { AdminRolesState } from './states/adminRoles-state/adminRoles.state';
import { LaboratoriesState } from './states/laboratories-state/laboratories.state';
import { RegionsState } from './states/regions-state/regions.state';
import { MappingState } from './states/mapping-state/mapping.state';

registerLocaleData(localeNl);

export const storageFactory = (): OAuthStorage => localStorage;

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        UnauthorizedComponent,
        LoadingIndicatorComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        TasksModule,
        BrowserAnimationsModule,
        OAuthModule.forRoot({
            resourceServer: {
                allowedUrls: [environment.apiBaseUrl + '/api'],
                sendAccessToken: true
            }
        }),
        NgxsModule.forRoot([
            CustomersState,
            CustomerUsersState,
            PluginsState,
            TasksState,
            UserState,
            AdminRolesState,
            LaboratoriesState,
            RegionsState,
            ActionsState,
            MappingState
        ], {
            developmentMode: !environment.production
        }),
        NgxsReduxDevtoolsPluginModule.forRoot(),
        ToastrModule.forRoot({
            progressBar: true
        }),
        MaterialModule], providers: [
        AuthGuard,
        AuthService,
        UnsavedChangesService,
        interceptorProviders,
        { provide: 'API_BASE_URL', useValue: environment.apiBaseUrl },
        { provide: LOCALE_ID, useValue: 'nl-NL' },
        { provide: OAuthStorage, useFactory: storageFactory },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
